import {NgOptimizedImage} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, signal, WritableSignal} from '@angular/core';
import {LayoutService} from '../../services/layout.service';
import {CustomerService} from '../../services/customer.service';
import {TranslatePipe} from '../../pipes/translate.pipe';

@Component({
    selector: 'app-customer-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgOptimizedImage, TranslatePipe],
    template: `
    <img 
      [ngSrc]="useCustomerIconFallback() ? layoutService.getLogoByTheme() : customerService.publicCustomerResource()?.branding?.file?.path ?? ''" 
      [width]="300" 
      [height]="107"
      [alt]="('CUSTOMERIMAGE' | translate)" 
      (error)="useCustomerIconFallback.set(true)"
      class="img-fluid" 
      priority 
    />
  `
})
export class CustomerIconComponent {
  public layoutService: LayoutService = inject(LayoutService);
  public customerService: CustomerService = inject(CustomerService);

  public useCustomerIconFallback: WritableSignal<boolean> = signal<boolean>(false);
}
